import React from 'react';
import { styled } from '@mui/material/styles';

// 红球样式
const RedBall = styled('div', {
  shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'size'
})(({ selected, size = 'large' }) => {
  const dimensions = size === 'large' ? 48 : size === 'medium' ? 36 : size === 'small' ? 28 : 20;
  return {
    width: dimensions,
    height: dimensions,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
    fontSize: size === 'large' ? 18 : size === 'medium' ? 14 : size === 'small' ? 12 : 9,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    userSelect: 'none',
    backgroundColor: selected ? '#E53935' : '#FFFFFF',
    color: selected ? '#FFFFFF' : '#37474F',
    border: selected ? '2px solid #C62828' : '2px solid #CFD8DC',
    boxShadow: selected ? '0 4px 12px rgba(229, 57, 53, 0.3)' : 'none',
    transform: selected ? 'scale(1.05)' : 'scale(1)',
    '&:hover': {
      borderColor: selected ? '#B71C1C' : '#E53935',
      transform: 'scale(1.08)'
    },
    '&:active': {
      transform: 'scale(0.95)'
    }
  };
});

// 蓝球样式
const BlueBall = styled('div', {
  shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'size'
})(({ selected, size = 'large' }) => {
  const dimensions = size === 'large' ? 48 : size === 'medium' ? 36 : size === 'small' ? 28 : 20;
  return {
    width: dimensions,
    height: dimensions,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
    fontSize: size === 'large' ? 18 : size === 'medium' ? 14 : size === 'small' ? 12 : 9,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    userSelect: 'none',
    backgroundColor: selected ? '#1E88E5' : '#FFFFFF',
    color: selected ? '#FFFFFF' : '#37474F',
    border: selected ? '2px solid #1565C0' : '2px solid #CFD8DC',
    boxShadow: selected ? '0 4px 12px rgba(30, 136, 229, 0.3)' : 'none',
    transform: selected ? 'scale(1.05)' : 'scale(1)',
    '&:hover': {
      borderColor: selected ? '#0D47A1' : '#1E88E5',
      transform: 'scale(1.08)'
    },
    '&:active': {
      transform: 'scale(0.95)'
    }
  };
});

// 命中标记样式
const MatchBadge = styled('div')(() => ({
  position: 'absolute',
  top: -4,
  right: -4,
  width: 16,
  height: 16,
  borderRadius: '50%',
  backgroundColor: '#10B981',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 10,
  color: '#FFFFFF',
  fontWeight: 'bold',
  zIndex: 1
}));

/**
 * 选号球组件
 * @param {string} number - 号码（01-33）
 * @param {'red' | 'blue'} type - 球类型
 * @param {boolean} selected - 是否选中
 * @param {'large' | 'medium' | 'small'} size - 尺寸
 * @param {boolean} matched - 是否命中（用于开奖结果展示）
 * @param {function} onClick - 点击事件
 */
function LotteryBall({ number, type = 'red', selected = false, size = 'large', matched = false, onClick, disabled = false }) {
  const BallComponent = type === 'red' ? RedBall : BlueBall;

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      {matched && <MatchBadge>✓</MatchBadge>}
      <BallComponent
        selected={selected}
        size={size}
        onClick={!disabled ? onClick : undefined}
        style={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? 'default' : 'pointer' }}
      >
        {number}
      </BallComponent>
    </div>
  );
}

export default React.memo(LotteryBall);
